import React, { Component } from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import DocumentTitle from 'react-document-title'

import ProjectsListing, { ProjectStatusFilter } from '../ProjectsListing'

class ProjectsTab extends Component {
  static propTypes = {
    office: PropTypes.object
  }

  render () {
    const { id, officeName } = this.props.office

    return (
      <DocumentTitle title={`${officeName} - projects | Atheneum Partners`}>
        <ProjectsListing officeId={id}>
          {({ projectsListingStore }) => {
            return (
              <ProjectStatusFilter
                projectsListingStore={projectsListingStore}
              />
            )
          }}
        </ProjectsListing>
      </DocumentTitle>
    )
  }
}

export default observer(ProjectsTab)
